'use client'

import { DialogModal } from '@/shared/components/DialogModal'
import { useTfaStore } from '@/features/tfa/store'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { DialogTitle } from '@headlessui/react'
import TfaChallengeModal, {
  TFA_CHALLENGE_PANEL_CLASSES,
} from '@/features/tfa/TfaChallengeModal'

export default function TfaChallengeModalContainer() {
  const methods = useTfaStore((state) => state.methods)
  const completeTfaVerification = useTfaStore(
    (state) => state.completeTfaVerifications,
  )
  const cancelTfaVerification = useTfaStore(
    (state) => state.cancelTfaVerifications,
  )
  const updateTokenState = useTfaStore((state) => state.updateTokenState)
  const step = useTfaStore((state) => state.step)
  const completeTfaStep = useTfaStore((state) => state.completeTfaStep)
  const tfaError = useTfaStore((state) => state.tfaError)

  return (
    <DialogModal
      show={methods.length > 0}
      onClose={() => {}}
      motionPreset="editorial"
      panelClasses={TFA_CHALLENGE_PANEL_CLASSES}
    >
      {tfaError ? (
        <>
          <div className="sm:flex sm:items-start">
            <div className="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:size-10">
              <ExclamationTriangleIcon
                aria-hidden="true"
                className="size-6 text-red-600"
              />
            </div>
            <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
              <DialogTitle
                as="h3"
                className="text-base font-semibold text-gray-900"
              >
                {tfaError.title}
              </DialogTitle>
              <div className="mt-2">
                <p className="text-sm text-gray-500">{tfaError.description}</p>
              </div>
            </div>
          </div>
          <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
            <button
              type="button"
              onClick={async () => {
                await cancelTfaVerification()
              }}
              className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-5 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
            >
              Okay
            </button>
          </div>
        </>
      ) : (
        <TfaChallengeModal
          step={step}
          steps={methods}
          onCancelVerification={cancelTfaVerification}
          onResendCode={updateTokenState}
          incrementStep={async () => {
            if (step < methods.length - 1) {
              await completeTfaStep()
            } else {
              await completeTfaVerification()
            }
          }}
        />
      )}
    </DialogModal>
  )
}
